import React from 'react';

// UI
import {
  Box,
  Stack,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
} from '@mui/material';

import {
  Search as SearchIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@mui/icons-material';

// Redux & Sagas
import { ITeamSchema } from '../slice/types';

// Library
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import Path from 'config/clientPath';
import { COUNTRY_LIST } from 'constants/common';

export function FilterBar() {
  const { handleSubmit, register, reset, control, watch } = useForm();

  const searchForm = React.useRef<HTMLFormElement>();
  const history = useHistory();

  const handSearch = _formData => {
    const params = new URLSearchParams(window.location.search);
    const formData = params.get('page') ? { ..._formData, page: 1 } : _formData;
    const qs = Object.keys(formData)
      .map(key => (formData[key] ? key + '=' + formData[key] : ''))
      .filter(o => o)
      .join('&');
    history.push(`${Path.TEAM}?${qs}`);
  };

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    reset({
      country: params.get('country') || '',
      status: params.get('status') || '',
      name: params.get('name') || '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === 'country' || name === 'status') {
        requestSubmit();
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const requestSubmit = () => {
    setTimeout(() => searchForm.current?.requestSubmit(), 10);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      component="form"
      method="GET"
      ref={searchForm}
      onSubmit={handleSubmit(handSearch)}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <InputLabel>Status: </InputLabel>
        <FormControl>
          <Controller
            control={control}
            name="status"
            render={({ field }) => {
              const { onBlur, onChange, value } = field;
              return (
                <Select
                  fullWidth
                  displayEmpty
                  size="small"
                  variant="standard"
                  onBlur={onBlur}
                  onChange={onChange}
                  value={`${value}`}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="2">Deactive</MenuItem>
                </Select>
              );
            }}
          />
        </FormControl>

        <InputLabel>Country: </InputLabel>

        <FormControl>
          <Controller
            control={control}
            name="country"
            render={({ field }) => {
              const { onBlur, onChange, value } = field;
              return (
                <Select
                  fullWidth
                  displayEmpty
                  size="small"
                  variant="standard"
                  onBlur={onBlur}
                  onChange={onChange}
                  value={`${value}`}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value="">All</MenuItem>
                  {_.map(COUNTRY_LIST, (label, code) => (
                    <MenuItem value={code}>{label}</MenuItem>
                  ))}
                </Select>
              );
            }}
          />
        </FormControl>
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        {/*<InputLabel>View mode</InputLabel>
        <ToggleButtonGroup value="list" exclusive size="small">
          <ToggleButton value="list">
            <ViewModeListIcon />
          </ToggleButton>
          <ToggleButton value="user">
            <ViewModeUserIcon />
          </ToggleButton>
           <ToggleButton value="task">
            <ViewModeTaskIcon />
          </ToggleButton> 
        </ToggleButtonGroup>*/}
        <TextField
          type="search"
          placeholder="Search keyword"
          aria-label="Search"
          size="small"
          sx={{
            background: '#fff',
          }}
          onKeyUp={event => {
            if (event.key === 'Enter') {
              requestSubmit();
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          {...register<keyof ITeamSchema>('name')}
        />
      </Stack>
    </Box>
  );
}

export default FilterBar;
